export type Environment = 'production' | 'development' | 'local' | 'staging';

export interface AppConfig {
  apiUrl: string;
  memberBase: string;
  environment: Environment;
}

export const appConfig: AppConfig = {
  apiUrl: process.env.REACT_APP_API_URL!!,
  memberBase: process.env.REACT_APP_MEMBER_BASE!!,
  environment: (process.env.REACT_APP_ENV || 'local') as Environment,
};
